import { values } from "lodash";

import { CustomQuestionConfig, selectQuestionnaireAsQuestionnaireConfigFactory } from "../questionnaires/questionnaireConfig";

import { MedicalTypeId, HealthSurveillanceQuestionConfig, HealthSurveillanceSectionConfig, CustomMedicalType } from "./models";

import { HealthSurveillanceQuestionnaireKey } from "./components/OldHealthSurveillanceQuestionnaire";
import { sections as employeeQuestionnaireSections } from "./questionnaire";

/**
 * Filters an array of health surveillance questions based on the provided medical types.
 * @deprecated this does not support custom medical types,
 * use `questionConfigsForEmployeeQuestionnaireSelector` instead for employee questionnaire or create a new HS consultation version
 * @param questions - The array of health surveillance questions to filter.
 * @param medicalTypes - The array of medical types to filter by.
 * @returns {HealthSurveillanceQuestionConfig[]} - The filtered array of health surveillance questions.
 */
export const questionsForMedicalTypesSelector = (questions: HealthSurveillanceQuestionConfig[], medicalTypes: MedicalTypeId[]) => {
    return questions.filter(q => q.medicalTypes.some(t => medicalTypes.indexOf(t) !== -1));
};

export const questionConfigsForEmployeeQuestionnaireSelector = (
    medicalTypes: MedicalTypeId[],
    customMedicalTypeConfigs: CustomMedicalType[]
) => {
    const sectionsWithMedicals = values<HealthSurveillanceSectionConfig>(employeeQuestionnaireSections)
        .map(section => ({
            ...section,
            medicalTypes: [
                ...section.medicalTypes,
                ...customMedicalTypeConfigs
                    .filter(c => medicalTypes.indexOf(c.id) !== -1)
                    .filter(c => c.questionnaireSectionIds.indexOf(section.id) !== -1).map(c => c.id)
            ]
        }));
    const sectionsApplicableToGivenMedicals = sectionsWithMedicals
        .filter(section =>
            section.medicalTypes.some(t => medicalTypes.indexOf(t) !== -1) ||
            section.questionConfigs.some(q => "medicalTypes" in q && q.medicalTypes?.some(t => medicalTypes.indexOf(t) !== -1))
        );
    return sectionsApplicableToGivenMedicals
        .reduce<CustomQuestionConfig[]>((prevValue, currentValue) => [
            ...prevValue,
            ...currentValue.questionConfigs.filter(q =>
                currentValue.medicalTypes.some(t => medicalTypes.indexOf(t) !== -1) ||
                q.medicalTypes?.some(t => medicalTypes.indexOf(t) !== -1))
        ], []);
};

export const selectHealthSurveillanceQuestionnaireAsQuestionnaireConfig = selectQuestionnaireAsQuestionnaireConfigFactory(HealthSurveillanceQuestionnaireKey);
